import $ from 'jquery'
import SmoothScroll from 'smooth-scroll'

import { registerComponent } from '../app'
import { WINDOW_RESIZE, USER_SCROLL } from '../events'
import Scroll from '../services/Scroll'
import Browser from '../services/Browser'

const SectionNav = (scope, el) => {
	const props = {
		activeClass: 'active',
		visibleClass: 'visible'
	}

	const state = {
		offsets: []
	}

	const els = {
		links: [],
		sections: document.body.querySelectorAll('[data-section]')
	}

	const scroller = new SmoothScroll()

	function init() {
		if (!els.sections.length) return
		buildLinks()
		bindLinks()
		bindScroll()
		bindResize()
		setOffsets()
		updateNav()
		el.classList.add(props.visibleClass)
	}

	function buildLinks() {
		for (let i = 0; i < els.sections.length; i++) {
			let $link = $('<a href="">' + els.sections[i].getAttribute('data-section') + '</a>')
			els.links.push($link[0])
			el.appendChild($link[0])
		}
	}

	function bindLinks() {
		for (let i = 0; i < els.links.length; i++) {
			els.links[i].addEventListener('click', e => {
				e.preventDefault()
				scroller.animateScroll(
					document.querySelector('[data-section="' + e.target.textContent + '"]')
				)
			})
		}
	}

	function bindScroll() {
		scope.on(USER_SCROLL, updateNav.bind(this))
	}

	function bindResize() {
		scope.on(WINDOW_RESIZE, () => {
			setTimeout(() => {
				setOffsets()
				updateNav()
			}, 500)
		})
	}

	function setOffsets() {
		state.offsets = []
		for (let i = 0; i < els.sections.length; i++) {
			state.offsets.push($(els.sections[i]).offset().top)
		}
	}

	function updateNav() {
		let position = Scroll.position()
		for (let i = 0; i < els.links.length; i++) {
			els.links[i].classList.remove(props.activeClass)
		}
		let scrolledPast = 0
		state.offsets.map((offset, index) => {
			scrolledPast = offset < position + Browser.height() * 0.5 ? index : scrolledPast
		})
		els.links[scrolledPast].classList.add(props.activeClass)
	}

	scope.start(init)
}

registerComponent('section-nav', SectionNav)
